import { BASIC_NODE_CONFIG, BASIC_NODE_CONFIG_SIZE } from 'src/utils/basic'
import type { InputNodeType } from '../types'

export function generateInputNodeConfig(): InputNodeType {
  return {
    ...BASIC_NODE_CONFIG,
    id: '0',
    type: 'input',
    data: {
      ...BASIC_NODE_CONFIG_SIZE,
      nodeName: '输入节点',
      nodeType: 'input',
      nodeData: {},
      nodeStyle: {},
      nodeId: '',
      hasErr: false,
      errInfo: [],
    },
    deletable: false,
    position: {
      x: 0,
      y: 0,
    },
  }
}
